<template>
  <b-row>
    <b-col sm="12" md="6" xl="3" lg="6">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-email-outline"
          :title="$t('pages.dashboard.top_cards.sent')"
          :value="statistics.data && statistics.data.sent_email_count"
      />
    </b-col>
    <b-col sm="12" md="6" xl="3" lg="6">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-message-alert-outline"
          :title="$t('pages.dashboard.top_cards.negative_feedback')"
          :value="statistics.data && statistics.data.negative_feedback_count"
      />
    </b-col>
    <b-col sm="12" md="6" xl="3" lg="6">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-message-plus-outline"
          :title="$t('pages.dashboard.top_cards.positive_review')"
          :value="statistics.data && statistics.data.positive_review_count"
      />
    </b-col>
    <b-col sm="12" md="6" xl="3" lg="6">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-message-minus-outline"
          :title="$t('pages.dashboard.top_cards.negative_review')"
          :value="statistics.data && statistics.data.negative_review_count"
      />
    </b-col>
  </b-row>
</template>

<script>
import Stat from "@/components/widgets/stat";

export default {
  name: "HeaderCards",
  props: ['statistics'],
  components: {
    Stat
  }
}
</script>

<style scoped>

</style>